<template>
  <div style="background: #fff">
    <div class="home_con">
      <div class="home_tit">公司简介</div>
      <div class="compay_con">
        <div class="compay_left">
          <p class="left_tit">和瑞众联科技（北京）有限公司</p>
          <p class="left_con">
            是一家新兴的新能源科技企业，致力于让充电更简单；经过对新能源领域不断探索及开发投入，目前公司已经在充电生态各关键节点进行产品开发布局。<br /><br />

            上游针对电源管理的智慧能源管理系统及配套储能产品结合中游场站智能AI运营系统及SaaS业务平台，赋能充电运营商，助力运营商实现“降本增效”提供低成本、高效率的解决方案。<br /><br />

            末端智能充电终端等业务链产品线；通过软硬件配套解决方案实现让建站更简单，让充电更简单，为充电客户提供全生命周期的服务生态。
          </p>
          <p class="left_con_mo">
            一家新兴的新能源科技企业，致力于让充电更简单；经过对新能源领域不断探索及开发投入，目前公司已经在充电生态各关键节点进行产品开发布局。<br /><br />
          </p>
          <p class="left_con_mo_hide" v-if="flag">
            上游针对电源管理的智慧能源管理系统及配套储能产品结合中游场站智能AI运营系统及SaaS业务平台，赋能充电运营商，助力运营商实现“降本增效”提供低成本、高效率的解决方案。<br /><br />

            末端智能充电终端等业务链产品线；通过软硬件配套解决方案实现让建站更简单，让充电更简单，为充电客户提供全生命周期的服务生态。
          </p>
          <div class="show_text" @click="showTag">
           
            <img
              :src="flag ? 'https://www.bjecpower.com/camera/company/sq2x.png' : 'https://www.bjecpower.com/camera/company/zk2x.png'"
              alt=""
            />
          </div>
          <ul>
            <li><img src="@/assets/pc/aa.png" alt="" /><span>新能源</span></li>
            <li>
              <img src="@/assets/pc/bb.png" alt="" /><span>智慧能源</span>
            </li>
            <li><img src="@/assets/pc/cc.png" alt="" /><span>储能</span></li>
            <li><img src="@/assets/pc/dd.png" alt="" /><span>智能AI</span></li>
            <li>
              <img src="@/assets/pc/ee.png" alt="" /><span>终端设备</span>
            </li>
          </ul>
        </div>
        <div class="compay_right">
          <img src="@/assets/comp.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "company",
  data() {
    return {
      flag: false,
    };
  },

  methods: {
    showTag() {
      this.flag = !this.flag;
    },
  },
};
</script>

<style scoped>
.left_tit {
  color: #000000;
}
.left_con {
  color: #5a6073;
}
.compay_con {
    display: flex;
    width: 100%;
    padding-bottom: 10%;
  }
  .show_text {
    display: none;
  }
  .compay_left {
    width: 53%;
    text-align: left;
  }
  .left_tit {
    font-size: 28px;
    font-weight: 500;

    line-height: 28px;
  }
  .left_con_mo,
  .left_con_mo_hide {
    display: none;
  }
  .left_con {
    padding: 30px 0px 16px 0px;
    border-bottom: 1px solid #e5e5e5;
    font-size: 14px;

    font-weight: 400;

    line-height: 21px;
    text-align: left;
  }
  .compay_left ul {
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
  }
  .compay_left ul li {
    display: flex;
    align-items: center;
  }
  .compay_left ul li img {
    width: 25px;
    height: 25px;
  }
  .compay_left ul li span {
    margin-left: 7px;
    font-size: 14px;

    font-weight: 400;
    color: #5a6073;
    line-height: 21px;
  }
  .compay_right {
    width: 418px;
    height: 315px;
    margin-left: 8%;
  }
  .compay_right img {
    width: 100%;
    height: 100%;
  }
@media screen and (max-width: 1440px) {
  
}
@media screen and (max-width: 768px) {
  .compay_left ul,
  .left_tit,
  .compay_right {
    display: none;
  }
  .compay_left {
    width: 100%;
    /* margin: 0 15px; */
  }
  .compay_con {
    display: flex;
    width: 100%;
    padding-bottom: 0%;
  }
  .left_con_mo,
  .left_con_mo_hide {
    font-size: 14px;
    color: #5a6073;
    font-weight: 400;
    display: block;
    line-height: 21px;
    text-align: left;
    margin:0px 15px;
  }
  .left_con {
    display: none;
    padding: 0px 0px 0px 0px;
    border: none;
  }
  .show_text {
    display: flex;
    justify-content: center;
    margin: 16px auto;
    align-items: center;
    width: 101px;
    height: 33px;
    /* background: linear-gradient(
      270deg,
      rgba(0, 132, 255, 0) 0%,
      rgba(0, 132, 255, 0.64) 49%,
      rgba(0, 132, 255, 0) 100%
    ); */
    /* opacity: 0.1; */
  }
  .show_text span {
    font-size: 14px;
    font-weight: 500;
    color: #0084ff;
    line-height: 20px;
  }
  .show_text img {
    width: 101px;
    height: 33px;
    /* margin-left: 8px; */
  }
}
</style>


// WEBPACK FOOTER //
// src/components/company.vue